"use strict";

define('uikit/collections/tree',['require','exports','module','marionette','../mixins/component.mixin','../channel','../templates','semantic/modules/accordion'],function (require, exports, module) {
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('../templates');
  require('semantic/modules/accordion');
  var ContentViewContainer = '> .content';
  var TreeItem = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'node',
    template: Templates.UIKit['tree.item'],
    tagName: 'div',
    options: {
      selectable: true,
      selected: false,
      link: false,
      target: null,
      icon: null,
      text: ''
    },
    update: {
      selected: false,
      selectable: false
    },
    childViewContainer: ContentViewContainer,
    childViewEventPrefix: 'leaf',
    childViewOptions: function childViewOptions() {
      return {
        root: this.getOption('root'),
        bindings: _.clone(this.bindings)
      };
    },
    events: {
      'click @ui.title': 'handleTitlePress',
      'keydown @ui.title': 'handleTitleKeydown',
      'keydown @ui.expandIcon': 'handleExpandKeydown',
      'click @ui.expandIcon': 'handleExpandPress'
    },
    ui: {
      content: '> .content',
      title: '> .title',
      expandIcon: '> .title > .dropdown.icon'
    },
    initialize: function initialize() {
      if (this.model.attributes['data-name'] === 'reporting' && !$(this.el).hasClass('reporting-tree-item')) {
        $(this.el).addClass('reporting-tree-item');
      }
      if (this.model.attributes['data-name'] === 'meetings' && !$(this.el).hasClass('meetings-tree-item')) {
        $(this.el).addClass('meetings-tree-item');
      }
      if (this.model.attributes['data-name'] === 'tasks' && !$(this.el).hasClass('tasks-tree-item')) {
        $(this.el).addClass('tasks-tree-item');
      }
      ComponentMixin.initialize.apply(this, arguments);
      this.root = this.getOption('root');
    },
    handleTitlePress: function handleTitlePress(ev) {
      this.handleTriggerLeafPress();
    },
    handleTitleKeydown: function handleTitleKeydown(ev) {
      if (ev.keyCode == 13) {
        this.handleTriggerLeafPress();
      }
    },
    handleTriggerLeafPress: function handleTriggerLeafPress() {
      if (this.link) {
        this.ui.title.find('> a').get(0).click();
        return;
      }
      this.root.triggerMethod('leaf:press', this);
    },
    handleExpandKeydown: function handleExpandKeydown(ev) {
      if (ev.keyCode == 13) {
        ev.stopPropagation();
        this.root.triggerMethod('leaf:expand', this);
      }
    },
    handleExpandPress: function handleExpandPress(ev) {
      ev.stopPropagation();
      this.root.triggerMethod('leaf:expand', this);
    },
    onRender: function onRender() {
      if (!this.children.length) {
        this.ui.content.remove();
        this.ui.expandIcon.hide();
      }
    },
    updateAttributes: function updateAttributes() {
      this.addClass('selected', this.getBoolOption('selected'));
    },
    serializeData: function serializeData() {
      var data = ComponentMixin.serializeData.apply(this, arguments);
      if (this.link && _.isString(this.link)) {
        data.href = this.link;
      }
      return data;
    }
  });
  var Tree = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'ui tree accordion',
    attributes: {
      tabindex: 0
    },
    childView: TreeItem,
    childViewContainer: ContentViewContainer,
    childViewOptions: function childViewOptions() {
      return {
        root: this
      };
    },
    options: {
      collapsible: true,
      selected: null,
      exclusive: false,
      styled: false,
      fluid: false,
      inverted: false
    },
    update: {
      selected: false,
      fluid: false,
      styled: false,
      inverted: false
    },
    onLeafPress: function onLeafPress(leaf) {
      if (leaf.children.length) {
        this.toggle(leaf.ui.title);
      }
      this._internal.selected = leaf.model;
    },
    onLeafExpand: function onLeafExpand(leaf) {
      if (leaf.children.length) {
        this.toggle(leaf.ui.title);
      }
    },
    findLeafByModel: function findLeafByModel(model) {
      function findLeaf(parent) {
        var view = parent.children.findByModel(model);
        if (!view) {
          parent.children.each(function (child) {
            if (!view) {
              view = findLeaf(child);
            }
          });
        }
        return view;
      }
      ;
      return findLeaf(this);
    },
    onFirstRender: function onFirstRender() {
      this.on('change:selected', function (view, value, previous) {
        var previousView = null,
          transitionModule = null;
        if (previous) {
          previousView = this.findLeafByModel(previous);
        }
        if (previousView) {
          transitionModule = previousView.$el.data().moduleTransition;
        }
        if (transitionModule && transitionModule.is.animating()) {
          previousView.$el.one(transitionModule.get.animationEndEvent(), function () {
            previousView.selected = false;
          });
        } else if (previousView) {
          previousView.selected = false;
        }
        this._onChangeSelected();
      });
      this._onChangeSelected();
    },
    _onChangeSelected: function _onChangeSelected() {
      var selected = this.selected,
        view = null;
      if (selected) {
        view = this.findLeafByModel(selected);
      }
      if (view && view.selectable) {
        view.selected = true;
      }
    },
    onRender: function onRender() {
      var options = _.extend({
          selector: {
            trigger: '.nope'
          }
        }, this.options),
        self = this;
      _.each(['opening', 'open', 'closing', 'close', 'change'], function (name) {
        var fnName = 'on' + name.slice(0, 1).toUpperCase() + name.slice(1);
        options[fnName] = function () {
          self.triggerMethod('accordion:' + name, self);
        };
      }, this);
      this.$el.accordion(options);
    },
    open: function open(index) {
      this.$el.accordion('open', index);
      return this;
    },
    close: function close(index) {
      this.$el.accordion('close', index);
      return this;
    },
    toggle: function toggle(index) {
      this.$el.accordion('toggle', index);
      return this;
    },
    updateAttributes: function updateAttributes() {
      this.addClass('styled', this.getBoolOption('styled')).addClass('fluid', this.getBoolOption('fluid')).addClass('inverted', this.getBoolOption('inverted'));
    }
  });
  Tree.TreeItem = TreeItem;
  channel.reply('tree', function () {
    return Tree;
  });
  module.exports = Tree;
});

